import React from "react";

function BtnList(props){
  return(
    <button type="button" className="list-group-item list-group-item-action"  onClick={props.onClick}>
      {props.text}
    </button>
  );
}

class MenuAspirante extends React.Component {
    constructor(props){
      super(props);
      this.state = {
        value:props.value,
        trigger: false,
        opciones:[]
      };

      this.triggetNext = this.triggetNext.bind(this);
    }

    triggetNext(value,trigger) {
      this.setState({ trigger: true,value:value }, () => {
        this.props.triggerNextStep({value: value,trigger: trigger});
      });
      let arry = [...document.getElementsByClassName("list-group-item")];
      arry.forEach(btn => btn.disabled = true);

    }

    renderButton(texto,opc,trigger){
      return(
        <BtnList 
          text={texto}
          onClick={()=>this.triggetNext(opc,trigger)}
        />
      );
    }

    componentDidMount() {
      let url = 'http://127.0.0.1/api/menu_aspirante/menu';
      fetch(url)
        .then(response => response.json())
        .then(data => {
          // Descomentar la siguiente línea para revisar la respuesta del API
          console.log(data);
          //Actualiza el estado de la prop del componente respuesta con la respuesta del api 
          this.setState({ opciones:data });
          
         
        })
        .catch(error => {
          // Aquí se maneja el error si es que falla la consulta al API
          this.setState({ opciones:[{'opcion':'No se pudo establecer conexion con el servidor','id':1,'nextstep':'mainmenu'}] });
          //Imprime el error en consola en la siguiente linea 
          console.error(error);
        });
        
    }

  
    render() {
      const {opciones} = this.state;
      return (
        <div id="menuAsp" className="list-group">
        {
          opciones.map((opcion, index) => (
            this.renderButton(opcion.opcion, opcion.id, opcion.nextstep)
          ))
        }
        </div>
      );
    }
  }

  MenuAspirante.defaultProps = {
    value: 0
  };
  

  
  
  export default MenuAspirante;